import type { CurrentPitcher } from '../state/selectors';
import { teamColor } from '../state/teamColors';
import type { PlayerSeed } from './PlayerModal';
import styles from './PitcherChip.module.css';

interface PitcherChipProps {
  pitcher: CurrentPitcher;
  awayTeamCode: string;
  homeTeamCode: string;
  onClick?: (seed: PlayerSeed) => void;
}

export default function PitcherChip({ pitcher, awayTeamCode, homeTeamCode, onClick }: PitcherChipProps): JSX.Element {
  const code = pitcher.side === 'away' ? awayTeamCode : homeTeamCode;
  const { primary } = teamColor(code);
  return (
    <button
      type="button"
      data-testid="pitcher-chip"
      className={styles.chip}
      onClick={() => onClick?.({ id: pitcher.id, name: pitcher.name, jersey: pitcher.jersey, position: 'P' })}
      aria-label={`Pitcher ${pitcher.name}, ${pitcher.pitchesThrown} pitches, ${pitcher.inningsPitched} innings pitched`}
    >
      <span className={styles.badge} style={{ background: primary }}>
        {pitcher.jersey ?? 'P'}
      </span>
      <span className={styles.name} data-testid="pitcher-name">{pitcher.name}</span>
      <span className={styles.stats} data-testid="pitcher-stats">
        <span className={styles.statItem}><strong>P</strong>{pitcher.pitchesThrown}</span>
        <span className={styles.statItem}><strong>PC</strong>{pitcher.pitchesThisAtBat}</span>
        <span className={styles.statItem}><strong>IP</strong>{pitcher.inningsPitched}</span>
      </span>
    </button>
  );
}
